<template lang="pug">
.container-fluid
	.row
		.col-xs-12.col-sm-6.col-md-6.col-lg-4.col-xl-3
			.card
				.card-header Nueva alerta
				.card-body
					.form-group
						label.label Título
						.input-group
							.input-group-prepend
								button.btn.btn-warning(@click="seleccionaIcono = true")
									span(:class="alerta.Icono")
							input.form-control(v-model="alerta.Titulo")
					.form-group
						label.label Descripción
						textarea.form-control(v-model="alerta.Descripcion", rows="5")
					.form-group
						label.label Fecha de inicio
						datepicker(
							v-model="alerta.FechaInicio"
							inputClass="form-control"
						)
					.form-group
						label.label Fecha de fin
						datepicker(
							v-model="alerta.FechaFin"
							inputClass="form-control"
						)

				.card-footer
					button.btn.btn-primary(
						@click="guardar()"
					)
						span.mr-2
							.fa.fa-save
						span Guardar

		.col-xs-12.col-sm-6.col-md-6.col-lg-8.col-xl-9
			.card
				.card-header Alertas vigentes (no se muestran las pasadas)
				table.table.table-striped
					thead.bg-dark.text-white
						tr
							th
							th Título
							th Descripción
							th Inicio
							th Fin
							th
					tbody
						tr(
							v-for="alerta in alertas"
							:key="alerta.id"
							@click="editarAlerta(alerta)"
						)
							td.text-center
								span(:class="alerta.Icono")
							td {{ alerta.Titulo }}
							td {{ alerta.Descripcion }}
							td {{ alerta.FechaInicio }}
							td {{ alerta.FechaFin }}
							td
								button.btn.btn-sm.btn-danger(
									@click="borrar($event, alerta)"
								)
									.fa.fa-trash

		SeleccionarIconos(
			v-if="seleccionaIcono"
			@close="seleccionaIcono = false"
			@seleccion="alerta.Icono = $event"
		)
</template>

<script>
import SeleccionarIconos from './seleccion-icono'

export default {
	components: {
		SeleccionarIconos
	},
	data () {
		return {
			alertas: [],
			seleccionaIcono: false,
			alerta: {
				id: this.$uuid.generate(),
				Titulo: '',
				Descripcion: '',
				Icono: 'fa fa-exclamation-triangle',
				FechaInicio: new Date(),
				FechaFin: new Date()
			},
			editar: false
		}
	},
	created () {
		this.getListado()
	},
	methods: {
		borrar (ev, alerta) {
			ev.preventDefault()
			ev.stopPropagation()
			this.$http.delete('muro/php/ddd/Infrastructure/DeleteAlertaController.php?AlertaID=' + alerta.id)
				.then(() => {
					this.getListado()
				})
				.catch((e) => {
					console.error(e)
				})
		},
		editarAlerta (alerta) {
			this.editar = true
			this.alerta = JSON.parse(JSON.stringify(alerta))
		},
		reiniciar () {
			this.editar = false
			this.alerta.id = this.$uuid.generate()
			this.alerta.Titulo = ''
			this.alerta.Descripcion = ''
			this.alerta.FechaFin = new Date()
			this.alerta.FechaInicio = new Date()
			this.alerta.Icono = 'fa fa-exclamation-triangle'
		},
		getListado () {
			const inicio = new Date()
			inicio.setHours(0)
			inicio.setMinutes(0)
			inicio.setSeconds(0)
			inicio.setDate(inicio.getDate() + 1)
			const fin = new Date()
			fin.setDate(inicio.getDate() + 1)
			fin.setFullYear(fin.getFullYear() + 10)
			const form = {
				fecha_inicio: inicio,
				fecha_fin: fin
			}
			console.log(form.fecha_inicio)
			console.log(form.fecha_fin)
			this.$http.post('muro/php/ddd/Infrastructure/GetAlertasController.php', form)
				.then((res) => {
					this.alertas = res.data
				})
				.catch((e) => {
					console.error(e)
				})
		},
		guardar () {
			let method = 'post'
			if (this.editar) {
				method = 'patch'
			}
			this.$http({
				method,
				url: 'muro/php/ddd/Infrastructure/PostAlertaController.php',
				data: this.alerta
			})
				.then(() => {
					this.reiniciar()
					this.getListado()
					this.$store.commit('toast/success', {titulo: 'Creada'})
				})
				.catch(e => {
					this.$alert('Error', e.response.data.error)
				})
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/alertas/gestion-alertas.vue